import { render } from "./designDeptPrint.vue?vue&type=template&id=fd31efe6"
import script from "./designDeptPrint.vue?vue&type=script&lang=js"
export * from "./designDeptPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__